import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styles from './ReviewCard.module.css'
import { Review } from './reviewTypes'
import { ReviewStars } from './ReviewStars'
import { formatReviewDate } from '~/utils/googleReviews'

export interface ReviewCardProps {
  review: Review
}

export const ReviewCard: React.FC<ReviewCardProps> = ({ review }) => {
  const intl = useIntl()
  const { rating, author, text, publishedAt, imageUrl, language } = review

  const hasImage = Boolean(imageUrl)
  // On the Russian site a Russian review must not announce that its original
  // language is Russian — the badge only helps when the two differ.
  const showLanguage =
    language !== intl.locale && (language === 'ru' || language === 'ro')

  return (
    <article
      className={`${styles.card} ${!hasImage ? styles.cardNoImage : ''}`}
    >
      {hasImage && (
        <div className={styles.imageWrapper}>
          <img src={imageUrl} alt={author} className={styles.image} />
        </div>
      )}

      <div className={styles.content}>
        <header className={styles.headerRow}>
          <div className={styles.headerLeft}>
            <ReviewStars rating={rating} size="sm" />
          </div>
          <div className={styles.date}>
            {formatReviewDate(publishedAt, intl.locale)}
          </div>
        </header>

        <h3 className={styles.title}>{author}</h3>

        <p className={styles.body}>{text}</p>

        {showLanguage && (
          <div className={styles.originalRow}>
            <span className={styles.originalLabel}>
              <FormattedMessage id="reviews.language.label" />
              {intl.formatMessage({ id: `reviews.language.${language}` })}
            </span>
          </div>
        )}
      </div>
    </article>
  )
}
